import { FunctionComponent } from "react";
import { CheckCircleFilled } from "@ant-design/icons";

interface CheckLabelProps {
  text: string;
  isChecked?: boolean;
}

const CheckedLabel: FunctionComponent<CheckLabelProps> = ({
  text,
  isChecked = false,
}) => {
  return (
    <div className="checked-label">
      <span className={`checked-label-text ${isChecked ? "valid" : ""}`}>
        {text}
      </span>
      {isChecked && <CheckCircleFilled className="check-sign" />}
    </div>
  );
};

export default CheckedLabel;
